import type { SelectorFunction, SelectorStrategy, WorkerInstance } from './types.js'

function randomSelector(workers: WorkerInstance[]): WorkerInstance {
  const index = Math.floor(Math.random() * workers.length)
  return workers[index]
}

function firstSelector(workers: WorkerInstance[]): WorkerInstance {
  return workers[0]
}

function createRoundRobinSelector(): SelectorFunction {
  const counters = new Map<string, number>()

  return function roundRobinSelector(workers, workerName) {
    const count = counters.get(workerName) || 0
    const index = count % workers.length
    counters.set(workerName, count + 1)
    return workers[index]
  }
}

export function getSelector(
  selector: SelectorStrategy | SelectorFunction = 'random',
): SelectorFunction {
  if (typeof selector === 'function') {
    return selector
  }

  switch (selector) {
    case 'first':
      return firstSelector
    case 'round-robin':
      return createRoundRobinSelector()
    default:
      return randomSelector
  }
}
